import { render, staticRenderFns } from "./resetPw_vn.vue?vue&type=template&id=27582eab&scoped=true&"
import script from "./resetPw_vn.vue?vue&type=script&lang=js&"
export * from "./resetPw_vn.vue?vue&type=script&lang=js&"
import style0 from "./resetPw_vn.vue?vue&type=style&index=0&id=27582eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27582eab",
  null
  
)

export default component.exports